var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "item_box" },
      [
        _c(
          "div",
          { staticStyle: { "font-weight": "600", "font-size": "18px" } },
          [_vm._v("平台·拼多多")]
        ),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": _vm.marginWidth,
                          label: "结算模式:",
                          prop: "mode",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 0 },
                            model: {
                              value: _vm.ruleForm.mode,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "mode", $$v)
                              },
                              expression: "ruleForm.mode",
                            },
                          },
                          [_vm._v("月结")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 1 },
                            model: {
                              value: _vm.ruleForm.mode,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "mode", $$v)
                              },
                              expression: "ruleForm.mode",
                            },
                          },
                          [_vm._v("日结")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ruleForm.mode === 1
                  ? _c("el-form-item", { attrs: { label: "日结规则" } }, [
                      _c("div", { staticClass: "flex div_box" }, [
                        _c("div", { staticStyle: { padding: "0 20px" } }, [
                          _vm._v("每笔订单总佣金高于"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "amount",
                                  "label-width": _vm.marginWidth,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.amount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "amount", $$v)
                                    },
                                    expression: "ruleForm.amount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { padding: "0 20px" } }, [
                          _vm._v("元，确认收货满"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "delay",
                                  "label-width": _vm.marginWidth,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.delay,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "delay", $$v)
                                    },
                                    expression: "ruleForm.delay",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { padding: "0 20px" } }, [
                          _vm._v("天，每天0点后自动结算"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "normal",
                            "margin-top": "20px",
                            color: "#e6a23c",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "当单笔订单总佣金小于等于设定金额，在确认收货后的第二天凌晨3点左右，系统会自动结算到会员余额（无需满足后面的“确认收货满N天”）"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "若订单总佣金大于设定金额，则需在确认收货后，再经过设定的“确认收货满N天”之后的凌晨3点，结算到会员账户余额内"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#f56c6c",
                            "line-height": "normal",
                          },
                        },
                        [_vm._v("注意，仅处理联盟已结算的订单！")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.save } },
                      [_vm._v(" 保存 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }